(function () {
    "use strict";

    var serviceId = "leadService";

    angular
        .module("app.common")
        .factory(serviceId, ["userSvc", "ngDialog", "consultancy_factory", 'notifierSvc', '$translate', '$rootScope', '$q', leadService]);

    function leadService(userSvc, ngDialog, consultancy_factory, notifierSvc, $translate, $rootScope, $q) {
        var obj = {
            openLeadForm: openLeadForm,
            createInternalLead: createInternalLead
        };

        return obj;
        function openLeadForm(url, agentId = null, geo = null) {
            ngDialog.open({
                templateUrl: "app/history/seller-lead-modal.html",
                showClose: false,
                controller: [
                    "$scope", "$timeout",
                    function ($scope, $timeout) {
                        window.dataLayer.push({
                            'event': 'danismanlık_talebi_click',
                            'page_location': window.location.href
                        });
                        var consultancySourceUserId = null;
                        if (agentId) {
                            consultancySourceUserId = agentId;
                        }
                        $scope.agentSelected = agentId ? true : false;
                        $scope.sellerLead = {
                            name: '',
                            surname: '',
                            email: '',
                            phone: 0,
                            description: '',
                            language: window.langCode(),
                            googleClickId: window.gclid,
                            googleClientId: window.gaclient,
                            googleSessionId: window.gasessionId,
                            googleSessionNumber: window.gasessionNumber,
                            consultancySourceUserId: consultancySourceUserId,
                            url,
                            geoInfo: geo,
                            permissions: [140, 150, 160]
                        };
                        try {
                            $scope.sellerLead.email = userSvc.info.Email;
                            if (userSvc.info.Details && userSvc.info.Details.profile) {
                                $scope.sellerLead.name = userSvc.info.Details.profile.name;
                                $scope.sellerLead.surname = userSvc.info.Details.profile.surName;
                                $scope.sellerLead.phone = userSvc.info.Details.phoneNumber;
                            }
                        } catch (error) {
                            console.log("error:", error);
                        }

                        // Turnstile state
                        $scope.ETToken = null;
                        $scope.captchaVerified = false;
                        $scope.isTurkishPhone = true;
                        $scope.eimageCaptchaKey = null;
                        $scope.eimageCaptchaValue = null;

                        $scope.isPhoneVerified = false;

                        $scope.showName = true;
                        $scope.showSurname = true;
                        $scope.showPhone = true;
                        if ($scope.sellerLead.name) {
                            $scope.showName = false;
                        }
                        if ($scope.sellerLead.surname) {
                            $scope.showSurname = false;
                        }
                        if ($scope.sellerLead.email) {
                            $scope.showEmail = false;
                        }
                        if ($scope.sellerLead.phone && $scope.sellerLead.phone.length > 5) {
                            $scope.showPhone = false;
                            $scope.isPhoneVerified = true;
                        }
                        $scope.isDisabled = true;

                        $scope.privacyAccepted = false;
                        $scope.contactAccepted = false;

                        $scope.privacyModal = function () {
                            ngDialog.open({
                                templateUrl: 'app/content/sozlesme/' + window.lang + '/lead.html',
                                controller: ['$scope', ($scope) => {
                                    $scope.onModal = true;
                                }]
                            });
                        };

                        $timeout(function () {
                            $('#firstInput').focus();
                        }, 100);

                        $scope.checkFields = function (input = null) {
                            // Telefon değiştiğinde doğrulamayı sıfırla
                            if ($scope.phoneValidation.changed) {
                                $scope.isPhoneVerified = false;
                            }
                            if ($scope.sellerLead.name && $scope.sellerLead.surname && $scope.sellerLead.phone) {
                                if ($scope.sellerLead.name.length < 2 || $scope.sellerLead.surname.length < 2 || $scope.privacyAccepted !== true || $scope.contactAccepted !== true) {
                                    $scope.isDisabled = true;
                                } else {
                                    $scope.isDisabled = false;
                                }
                            } else {
                                $scope.isDisabled = true;
                            }
                        };

                        // OTP onaylandığında çağrılacak callback
                        $scope.onPhoneVerified = function () {
                            $timeout(function () {
                                $scope.isPhoneVerified = true;
                            }, 100);
                        };

                        $scope.sendForm = function (isValid) {
                            if (!isValid) {
                                notifierSvc.show({ message: $translate.instant('not_valid'), type: 'error' });
                                return;
                            }
                            $scope.leadLoading = true;
                            userSvc
                                .getFinger()
                                .then(function (finger) {
                                    $scope.sellerLead.fingerPrint = finger;
                                    $scope.sellerLead.phone = $scope.sellerLead.phone ? $scope.sellerLead.phone.replace(/\s+/g, '') : null;

                                    consultancy_factory
                                        .createLead($scope.sellerLead)
                                        .$promise.then(function (res) {
                                            $scope.leadLoading = false;
                                            ngDialog.close();
                                            notifierSvc.show({
                                                message: $translate.instant(
                                                    "seller_lead_success"
                                                ),
                                                type: "success",
                                            });
                                        })
                                        .catch((err) => {
                                            console.log("lead form err:", err);
                                            notifierSvc.show({
                                                message: $translate.instant("seller_lead_error"),
                                                type: "error",
                                            });
                                            $scope.leadLoading = false;
                                            ngDialog.close();
                                        });
                                })
                                .catch(function (error) {
                                    console.log("lead form err:", error);
                                    $scope.leadLoading = false;
                                    notifierSvc.show({
                                        message: error.data.detail,
                                        type: "error",
                                    });
                                    ngDialog.close();
                                });
                        };
                    },
                ],
            });
        }

        function createInternalLead(lead) {
            var defer = $q.defer();
            consultancy_factory
                .createLead(lead)
                .$promise.then(function (res) {
                    ngDialog.close();
                    defer.resolve(res.value);
                })
                .catch((err) => {
                    console.log("lead form err:", err);
                    defer.reject(err);
                    ngDialog.close();
                });
            return defer.promise;
        }
    }
})();
